import { useState, useEffect, useCallback } from 'react';
import { type UserProfileData } from '@a1/shared';
import callAzureFunction from 'utils-ts/call-azure-function';
import handleError from 'utils-ts/handle-error';

export const useUserProfile = () => {
  const [profile, setProfile] = useState<UserProfileData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const loadProfile = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await callAzureFunction<UserProfileData | null>({
        url: 'profile-settings/me',
        method: 'get'
      });

      setProfile(data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProfile();
  }, [loadProfile]);

  return { profile, loading, refetch: loadProfile };
};
